import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Fallback pour récupérer le token depuis localStorage ou redux-persist
 */
export const getTokenFallback = () => {
  try {
    // 1) Fallback direct: auth_token dans localStorage
    const direct = localStorage.getItem('auth_token');
    if (direct) {
      return direct;
    }

    // 2) Fallback redux-persist: lire le state persisté
    const persistKey = 'root-genimi-parent-v3';
    const persistedState = localStorage.getItem(`persist:${persistKey}`);
    
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      
      if (parsed.userReducer) {
        const userReducer = typeof parsed.userReducer === 'string'
          ? JSON.parse(parsed.userReducer)
          : parsed.userReducer;
        const token = userReducer?.userInfo?.token;
        return token || null;
      }
    }
  } catch (error) {
    console.error('Erreur fallback token:', error);
  }
  
  return null;
};

export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    // credentials: 'include' retiré car on utilise JWT (Bearer token) pas de cookies
    // Cela évite les erreurs CORS quand le serveur renvoie Access-Control-Allow-Origin: *
    prepareHeaders: (headers, { getState }) => {
      // 1) Récupération depuis Redux state (prioritaire)
      const state = getState();
      const userInfo = state?.user?.userReducer?.userInfo;
      let csrf = userInfo?.csrfToken;
      let bearer = userInfo?.token || userInfo?.access_token;

      // 2) Fallback si le state n'est pas encore hydraté
      if (!bearer) {
        bearer = getTokenFallback();
        if (bearer) {
          console.log('[apiManager] Token récupéré depuis fallback');
        }
      }

      if (csrf) headers.set('X-CSRFToken', csrf);
      if (bearer) {
        headers.set('Authorization', `Bearer ${bearer}`);
      } else {
        console.warn('[apiManager] Aucun token disponible pour la requête');
      }

      return headers;
    },
  }),
  refetchOnReconnect: true,
  keepUnusedDataFor: 604800,
  reducerPath: "genimiApi",
  endpoints: () => ({}),
});

export const ApiMananger = baseApi.enhanceEndpoints({
  addTagTypes: [
    "Coachs",
    "Parents",
    "Fiches",
    "Users",
    "Eleves",
    "Appels",
    "comprehensions",
    "Paiements",
    "Evaluations",
    "Niveaux",
    "Classes",
    "Diagnostics",
  ],
});
